import { STATUS_LABELS, STATUS_ORDER } from "@/lib/api";
import { Warning } from "@phosphor-icons/react";

export function skippedBetween(from, to) {
  const a = STATUS_ORDER.indexOf(from);
  const b = STATUS_ORDER.indexOf(to);
  if (a < 0 || b < 0 || Math.abs(b - a) <= 1) return [];
  const [lo, hi] = a < b ? [a, b] : [b, a];
  return STATUS_ORDER.slice(lo + 1, hi);
}

export default function StageSelector({ fromStatus, value, onChange }) {
  const fromIdx = STATUS_ORDER.indexOf(fromStatus);
  const options = STATUS_ORDER.filter((s) => s !== fromStatus);
  const skipped = skippedBetween(fromStatus, value);
  return (
    <div data-testid="stage-selector">
      <div className="label mb-1.5">Escolha o próximo posto</div>
      <div className="grid grid-cols-2 gap-2">
        {options.map((s) => {
          const idx = STATUS_ORDER.indexOf(s);
          const isNext = idx === fromIdx + 1;
          const isBack = idx < fromIdx;
          const active = value === s;
          return (
            <button
              type="button"
              key={s}
              onClick={() => onChange(s)}
              className={`stage-option ${active ? "stage-option-active" : ""}`}
              data-testid={`stage-option-${s}`}
            >
              <span className={`dot ${s}`} />
              <span className="flex-1 text-left leading-tight">{STATUS_LABELS[s]}</span>
              {isNext && <span className="stage-tag stage-tag-next">Próximo</span>}
              {isBack && <span className="stage-tag">Voltar</span>}
            </button>
          );
        })}
      </div>
      {skipped.length > 0 && (
        <div className="stage-skip-warning mt-2 px-3 py-2 text-xs flex items-start gap-2" data-testid="stage-skip-warning">
          <Warning size={18} weight="fill" className="shrink-0 mt-0.5" />
          <span>
            <strong>Atenção:</strong> você está pulando o(s) posto(s):{" "}
            <strong>{skipped.map((s) => STATUS_LABELS[s]).join(", ")}</strong>.
            Avançar mais de um posto exige a permissão{" "}
            <strong>"Avançar pulando postos"</strong> concedida pelo administrador.
          </span>
        </div>
      )}
    </div>
  );
}
